import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCustomerName = simpleSet as
  redux.reducers.calculationMode.settings.information.customerName;

export const customerName = setCalculationModeCustomerName(
  'SET_CALCULATION_MODE_CUSTOMER_NAME',
  ''
);
